module.exports = "/_next/static/goCryptoWhite.svg";